import axios from 'axios';

let allLifestyleOrderCards = [];

// Fetch all lifestyle order cards from the JSON files
export const fetchAllLifestyleOrderCards = async () => {
  if (allLifestyleOrderCards.length > 0) {
    return allLifestyleOrderCards;
  }

  const cardCategories = [
    'nutrition',
    'movement',
    'mental_health',
    'sleep_recovery',
    'hormonal_health',
    'digestive_health',
    'immune_system',
    'environmental_health',
    'cognitive_health',
    'social_purpose',
    'detoxification'
  ];

  try {
    const cardPromises = cardCategories.map(category =>
      axios.get(`${window.location.origin}/configs/lifestyle/${category}.json`)
    );
    const cardResponses = await Promise.all(cardPromises);
    allLifestyleOrderCards = cardResponses.flatMap(response => response.data);
    return allLifestyleOrderCards;
  } catch (error) {
    console.error('Error fetching lifestyle order cards:', error);
    return [];
  }
};

// Evidence levels for clinical validation
export const EVIDENCE_LEVELS = {
  LEVEL_I: { level: 'I', description: 'Systematic review/meta-analysis of RCTs', color: '#22c55e' },
  LEVEL_II: { level: 'II', description: 'Individual RCT', color: '#84cc16' },
  LEVEL_III: { level: 'III', description: 'Controlled trial without randomization', color: '#eab308' },
  LEVEL_IV: { level: 'IV', description: 'Case-control or cohort study', color: '#f59e0b' }
};

// Difficulty levels for patient guidance
export const DIFFICULTY_LEVELS = {
  BEGINNER: { level: 'Beginner', color: '#22c55e', icon: '🟢' },
  INTERMEDIATE: { level: 'Intermediate', color: '#eab308', icon: '🟡' },
  ADVANCED: { level: 'Advanced', color: '#f97316', icon: '🟠' }
};

// Time commitment categories
export const TIME_COMMITMENTS = {
  MINIMAL: { label: '< 15 min/day', value: 'minimal', color: '#22c55e' },
  MODERATE: { label: '15-30 min/day', value: 'moderate', color: '#eab308' },
  SUBSTANTIAL: { label: '30-60 min/day', value: 'substantial', color: '#f97316' },
  INTENSIVE: { label: '> 60 min/day', value: 'intensive', color: '#dc2626' }
};

// Helper functions for card management
export const getCardsByCategory = (category, cards) => {
  return cards.filter(card => card.category === category);
};

export const getCardById = (id, cards) => {
  return cards.find(card => card.id === id);
};

export const searchCards = (query, cards) => {
  const searchTerm = query.toLowerCase();
  return cards.filter(card => 
    card.title.toLowerCase().includes(searchTerm) ||
    card.description.toLowerCase().includes(searchTerm) ||
    card.category.toLowerCase().includes(searchTerm) ||
    card.subcategory.toLowerCase().includes(searchTerm) ||
    card.smartGoals.some(goal => goal.toLowerCase().includes(searchTerm))
  );
};

export const getCardsByDifficulty = (difficulty, cards) => {
  return cards.filter(card => card.difficulty.level === difficulty);
};

export const getCardsByTimeCommitment = (timeCommitment, cards) => {
  return cards.filter(card => card.timeCommitment.value === timeCommitment);
};
